const PAGINATION_ANCHOR_SELECTOR = '.pagination a[href]';
let installed = false;

const readNewPage = (anchor: HTMLAnchorElement): number | null => {
    const raw = anchor.dataset.page;
    if (raw === undefined || !/^\d+$/.test(raw)) return null;
    const page = Number(raw);
    return Number.isSafeInteger(page) && page >= 1 ? page : null;
};

const onDocumentClick = (event: MouseEvent): void => {
    if (event.defaultPrevented) return;
    if (!(event.target instanceof Element)) return;
    const anchor = event.target.closest<HTMLAnchorElement>(PAGINATION_ANCHOR_SELECTOR);
    if (anchor === null) return;
    const newPage = readNewPage(anchor);
    if (newPage === null) return; // no/invalid data-page: emit nothing (fail-closed, see plan Approach)
    window.sbTracker?.track('pagination', { new_page: newPage });
};

/** One document-level delegated listener for every server-rendered `paginate.links` block (SB-6636). Idempotent. */
export const initPaginationTracker = (): void => {
    if (installed) return;
    installed = true;
    document.addEventListener('click', onDocumentClick);
};
